export enum ValidityRangeType {
    ANYTIME = 1,
    LIMITED = 2,
}

